// Spec 27 PR 2b — AgentMessage widget.
//
// Plain prose from the agent. Non-interactive. The simplest widget
// in the catalog. Renders as a single quiet paragraph in the
// dialogue column, no panel chrome, no avatar, no icon.

import type { WidgetRenderProps } from "../registry";

interface AgentMessageProps {
	text: string;
	secondary?: string | null;
}

export function AgentMessage({
	props,
}: WidgetRenderProps<AgentMessageProps>) {
	return (
		<div className="text-center space-y-1.5 py-2">
			<div className="text-[14px] leading-relaxed text-[var(--color-text)]">
				{props.text}
			</div>
			{props.secondary && (
				<div className="text-[12px] text-[var(--color-text-muted)]">
					{props.secondary}
				</div>
			)}
		</div>
	);
}
